import { createRoute, useParams } from "@tanstack/solid-router";
import { Show } from "solid-js";
import { notesRoute } from "./notes";
import { NotePageView } from "@/features/notes/components/note-page-view";
import { usePageMutations } from "@/features/notes/hooks/use-page-mutations";

function NotePage() {
  const params = useParams({ from: "/_app/documents/$pageId" });
  const mutations = usePageMutations();

  return (
    // keyed: remounts editor on page change (clean TipTap state)
    <Show when={params().pageId} keyed>
      {(pageId) => (
        <NotePageView
          pageId={pageId}
          onRename={(id, title) => {
            void mutations.handleRenamePage(id, title);
          }}
          onSetIcon={(id, icon) => {
            void mutations.handleSetPageIcon(id, icon);
          }}
          onRestoreVersion={(id, version) => mutations.executeRestoreVersion(id, version)}
        />
      )}
    </Show>
  );
}

export interface NotePageSearch {
  share?: boolean;
  icon?: boolean;
  versions?: boolean;
  comments?: boolean;
  attachment?: string;
}

export const notePageRoute = createRoute({
  getParentRoute: () => notesRoute,
  path: "/$pageId",
  // Addressable overlays for the note (`$pageId` is already in the route):
  // `?share=1` reopens the share dialog, `?icon=1` the icon selector,
  // `?versions=1` version history, `?attachment=<id>` expands the
  // preview of that specific attachment. Default values are omitted to
  // keep the URL clean.
  validateSearch: (search: Record<string, unknown>): NotePageSearch => ({
    share:
      search.share === true ||
      search.share === 1 ||
      search.share === "1" ||
      search.share === "true" ||
      undefined,
    icon:
      search.icon === true ||
      search.icon === 1 ||
      search.icon === "1" ||
      search.icon === "true" ||
      undefined,
    versions:
      search.versions === true ||
      search.versions === 1 ||
      search.versions === "1" ||
      search.versions === "true" ||
      undefined,
    comments:
      search.comments === true ||
      search.comments === 1 ||
      search.comments === "1" ||
      search.comments === "true" ||
      undefined,
    attachment:
      typeof search.attachment === "string" && search.attachment !== ""
        ? search.attachment
        : undefined,
  }),
  component: NotePage,
});
